import React from 'react';

// Hooks
import {
	useTutorialRunner,
	useTutorialSequence,
	useCollectedTutorialKeys
} from 'lib/hooks/useTutorial';

// Components
import TutorialManager from 'components/TutorialManager';

const TutorialManagerWrapper: React.FC = () => {
	const currentKey = useTutorialSequence(useCollectedTutorialKeys());

	const currentTutorialKey = useTutorialRunner(
		currentKey ? [currentKey] : []
	);

	if (!currentTutorialKey) return null;

	return <TutorialManager tutorialKey={currentTutorialKey} />;
};

export default TutorialManagerWrapper;

